<template>
    <slot
        v-bind="{
            selectSortFilter,
            registerFilterItem,
            itemFilters,
            currentCriteria,
            filteredOut,
            toggleFilterMenu,
            filterSortMenuActive,
            closeFilterMenu,
        }"
    />
</template>

<script>
// import Masonry from "masonry-layout";
import MiniMasonry from "@/vendor/minimasonry.js";

export default {
    name: "FilterSortContainer",

    props: {
        filterItems: Array,
    },

    data() {
        return {
            grid: null,
            currentCriteria: [],
            filterSortMenuActive: false,
        };
    },

    computed: {
        itemFilters() {
            const weightedItems = this.filterItems.reduce((carry, current) => {
                if (!carry.hasOwnProperty(current)) {
                    carry[current] = 0;
                }
                carry[current]++;

                return carry;
            }, {});

            const ranked = (obj, num = 1) => {
                const requiredObj = {};
                if (num > Object.keys(obj).length) {
                    return false;
                }
                Object.keys(obj)
                    .sort((a, b) => obj[b] - obj[a])
                    .forEach((key, ind) => {
                        if (ind < num) {
                            requiredObj[key] = obj[key];
                        }
                    });
                return requiredObj;
            };

            let rankedItems = ranked(
                weightedItems,
                Math.min(20, Object.keys(weightedItems).length)
            );

            rankedItems = Object.keys(rankedItems).reduce((ca, cu) => {
                return [...ca, cu];
            }, []);

            return [...new Set(rankedItems)].sort((a, b) => {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });
        },

        filteredItems() {
            return [...this.items].filter((item, index) => {
                if (!this.currentCriteria.length) {
                    return true;
                }

                return this.currentCriteria.some((cc) =>
                    item.criteria.includes(cc)
                );
            });
        },
    },

    async mounted() {
        // this.grid = new Masonry(".masonry-grid", {
        //     itemSelector: ".masonry-grid__item",
        //     gutter: 20,
        // });
        this.grid = new MiniMasonry({
            baseWidth: 320,
            container: ".masonry-grid",
            gutter: 20,
            surroundingGutter: false,
            wedge: true,
            ultimateGutter: 20,
        });

        window.addEventListener("resize", this.updateBaseWidth);
        this.updateBaseWidth();
    },

    methods: {
        registerFilterItem(item) {
            this.filterItems.push(item);
        },

        filteredOut(tags) {
            if (!this.currentCriteria.length) {
                return false;
            }

            return !this.currentCriteria.some((r) => tags.indexOf(r) >= 0);
        },

        selectSortFilter(filter) {
            if (this.currentCriteria.indexOf(filter.toLowerCase()) !== -1) {
                this.currentCriteria = this.currentCriteria.filter(
                    (i) => i != filter.toLowerCase()
                );
            } else {
                this.currentCriteria.push(filter.toLowerCase());
            }

            this.$nextTick(() => {
                this.grid.layout();
            });
        },

        toggleFilterMenu() {
            this.filterSortMenuActive = !this.filterSortMenuActive;
        },

        closeFilterMenu() {
            this.filterSortMenuActive = false;
        },

        updateBaseWidth() {
            if (window.innerWidth < 680) {
                this.grid.conf.baseWidth = 320;
            } else if (window.innerWidth < 1440) {
                this.grid.conf.baseWidth = 300;
            } else {
                this.grid.conf.baseWidth = 500;
            }

            this.$nextTick(() => {
                this.grid.layout();
            });
        },
    },

    onBeforeUnmount() {
        window.removeEventListener("resize", this.updateBaseWidth);
    },
};
</script>
